import { CloudRoom } from '@shure/cloud/shared/models/devices';

import { CloudRoomFragment } from '../graphql/generated/cloud-sys-api';

export function mapCloudRoomFromSysApi(cloudRoom: CloudRoomFragment | null | undefined): CloudRoom | undefined {
	if (!cloudRoom) {
		return undefined;
	}

	return {
		id: cloudRoom.id,
		name: cloudRoom.name,
		creationDate: new Date(), // TODO (bisem): update once creationDate field added to schema
		groupId: cloudRoom.group?.id,
		health: {
			worstSeverity: cloudRoom.health.worstSeverity ?? undefined
		}
	};
}
